import { render, staticRenderFns } from "./commonSelectComponent.vue?vue&type=template&id=68815868&scoped=true&"
import script from "./commonSelectComponent.vue?vue&type=script&lang=js&"
export * from "./commonSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./commonSelectComponent.vue?vue&type=style&index=0&id=68815868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68815868",
  null
  
)

export default component.exports